export default {
  // Endpoints
  loginEndpoint: 'https://tojtel.tj/api/tokens/create',
  registerEndpoint: 'https://tojtel.tj/api/signup',
  refreshEndpoint: 'https://tojtel.tj/api/auth/token/refresh-token',
  logoutEndpoint: 'https://tojtel.tj/api/auth/token/logout',
  confirmPhoneEndpoint: 'https://tojtel.tj/api/dealer/login',
  dealerVerifyStatus: 'https://tojtel.tj/api/dealer/verify-status',
  userChangeStatusApi: 'https://tojtel.tj/api/admin/user/{id}/change/status',
  orderNumberChangeStatusApi: 'https://tojtel.tj/api/admin/order/{id}/change/status',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
